import { useTileDataContext } from '~/contexts/TileDataContext';

type Props = {
  discountedPrice: number;
  showDiscount: boolean;
  showPriceDrop: boolean;
  totalDiscount: number;
};

export default function OriginalPrice({
  discountedPrice,
  showDiscount,
  showPriceDrop,
  totalDiscount
}: Props) {
  const {
    tileData: { previousPrice = 0 }
  } = useTileDataContext();
  const show = showDiscount || showPriceDrop;

  return show ? (
    <div data-qa="original-price" className="line-through">
      $
      {showPriceDrop
        ? previousPrice.toLocaleString()
        : (discountedPrice + totalDiscount).toLocaleString()}
    </div>
  ) : null;
}
